export type PromiseResolver<T> = (value: (T | PromiseLike<T>)) => void
export type PromiseRejector<T = any> = (reason?: T) => void

export function promiseResolve<T, U = never>() {
  let resolve: PromiseResolver<T> = () => {
  };
  let reject: PromiseRejector<U> = () => {
  };
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej
  })

  return {promise, resolve, reject}
}
